// frontend/src/components/DataTable/useCellEditor.js
import { useState } from 'react';

// 管理表格单元格编辑状态与提交行为。
export const useCellEditor = (onCellValueChange) => {
  const [editingCell, setEditingCell] = useState(null);
  const [draftValue, setDraftValue] = useState('');

  // 清理当前编辑状态。
  const resetEditor = () => {
    setEditingCell(null);
    setDraftValue('');
  };

  // 开始编辑指定单元格。
  const startEditing = (tableIndex, rowIndex, columnKey, value) => {
    setEditingCell({ tableIndex, rowIndex, columnKey });
    setDraftValue(String(value ?? ''));
  };

  // 提交当前编辑数值并触发回调。
  const commitEditing = () => {
    if (!editingCell) return;

    const parsed = Number(draftValue.trim());
    if (!Number.isFinite(parsed)) {
      resetEditor();
      return;
    }

    if (typeof onCellValueChange === 'function') {
      onCellValueChange(editingCell, Number(parsed.toFixed(2)));
    }

    resetEditor();
  };

  return {
    editingCell,
    draftValue,
    setDraftValue,
    startEditing,
    commitEditing,
    resetEditor,
  };
};
